<template>
  <div id="reports" class="page-layout__inner">
    <div :class="'page-layout__filter' + (filterSettings.visible ? '' : ' w-auto')">
      <section :class="'section  section--shadow-0  section--p-0' + (filterSettings.visible ? ' h-100' : '')">
        <button @click="filterSettings.visible = true"
                :class="'section__filter-btn' + (filterSettings.visible ? ' section__filter-btn--hidden' : '')">
          <svg class="section__filter-icon">
            <use xlink:href="#icon__layers"></use>
          </svg>
        </button>
        <div :class="'section__filter' + (filterSettings.visible ? '' : ' section__filter--hidden')">
          <div class="section__header">
            <h3 class="section__title">
              <svg class="section__filter-icon">
                <use xlink:href="#icon__layers"></use>
              </svg>
              {{ getTranslation('reports') }}
            </h3>
            <div class="section__controls">
              <div class="section__controls-group">
                <a @click="filterSettings.visible = false" class="btn  btn--xs  btn--control  js-filterHider"
                   href="javascript:void(0)">
                  {{ getTranslation('hide') }}
                </a>
                <a class="btn  btn--xs  btn--control" href="javascript:void(0)" @click="resetFilter()">
                  {{ getTranslation('reset') }}
                </a>
              </div>
            </div>
          </div>
          <div class="section__body">
            <div class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('reports') }}</label>
              <div class="list-group">
                <a @click="selectReport(report.id)" v-for="(report,key) in reports" v-bind:key="key"
                   href="javascript:void(0)" :class="{'active' : report.id===currentReport}"
                   class="list-group-item list-group-item-action">
                  {{ report.title }}
                </a>
              </div>
            </div>
            <div v-if="showReportType" class="form__group mt-4">
              <label class="radio  radio--inline">
                <input class="radio__input" type="radio" name="radioBtnSample1" v-model="filterForm.report"
                       value="ekyzmat">
                <span class="radio__indicator  radio__indicator--inline"></span>
                <span class="radio__label">{{ getTranslation('ekyzmat') }}</span>
              </label>

              <label class="radio  radio--inline">
                <input class="radio__input" type="radio" v-model="filterForm.report" name="radioBtnSample1"
                       value="local">
                <span class="radio__indicator  radio__indicator--inline"></span>
                <span class="radio__label">{{ getTranslation('local') }}</span>
              </label>
              <div class="form__descr">{{ getTranslation('localDesc') }}</div>
            </div>
            <div v-if="offices.length > 0 && showOffice" class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('office') }}</label>
              <v-select
                  v-if="showOffice "
                  :placeholder="getTranslation('selectFromList')"
                  label="title"
                  :reduce="option=>option.id"
                  :options="offices"
                  v-model="filterForm.officeId"
                  multiple
              />
            </div>
            <div v-if="contestTypes.length > 0 && showContestType" class="form__group">
              <label class="form__label  form__label--block">{{ getTranslation('contestType') }}</label>
              <v-select
                  v-if="showContestType"
                  :placeholder="getTranslation('selectFromList')"
                  label="title"
                  :reduce="option=>option.id"
                  :options="contestTypes"
                  v-model="filterForm.contestType"
              />
            </div>
            <div class="form__group">
              <label class="checkbox  checkbox--inline">
                <input class="checkbox__input" type="checkbox" v-model="filterForm.withTrial" value="1">
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ getTranslation('withTrial') }}</span>
              </label>
              <div class="form__descr">{{ getTranslation('withTrialDesc') }}</div>
            </div>
            <div class="form__group mt-4">
              <div class="form__tillfrom-row">
                <div>
                  <date-picker v-model="filterForm.dateFrom"></date-picker>
                </div>
                <div class="form__tillfrom-sep"></div>
                <div>
                  <date-picker v-model="filterForm.dateTo"></date-picker>
                </div>
              </div>
            </div>
            <div v-if="currentReport">
              <a @click="downloadReport(currentReport)" class="btn btn--full-width  btn--accent-outline"
                 href="javascript:void(0)">
                {{ getTranslation('download') }}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import reportMixin from "@/views/admin/reports/mixins/report";

export default {
  name: "Index",
  mixins: [reportMixin],
  data() {
    return {
      filterSettings: {
        visible: true
      },
      currentReport: '',
      showReportType: false,
      showOffice: false,
      showContestType: false,
      reports: [],
      offices: [],
      contestTypes: [],
      filterForm: {
        format: '.xlsx',
        report: 'ekyzmat',
        withTrial: true,
        download: false,
        dateTo: this.$moment().format('YYYY-MM-DD'),
        dateFrom: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
      }
    }
  },
  created() {
    this.setHeadings({
          title: this.getTranslation('reports'),
        },
    );
    this.fetchFormOptions();
  },
  methods: {
    resetFilter() {
      this.filterForm = {
        dateTo: this.$moment().format('YYYY-MM-DD'),
        dateFrom: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        format: '.xlsx'
      };
      this.currentReport = '';
    },

    fetchFormOptions() {
      return this.axios.get(this.$config.urls.report.formOptions.url).then(response => {
        this.reports = response.data.data.reports.map(item => {
          return {
            id: item,
            title: this.getTranslation(item)
          }
        });

        this.offices = response.data.data.offices;
        this.contestTypes = this.objectToArray(response.data.data.contestTypes, true, true);
      }).catch(() => {
      })
    },

    selectReport(report) {

      this.currentReport = report;

      switch (report) {
        case 'REPORT_GENERAL':
        case 'REPORT_GOV_SERVICE':
        case 'REPORT_MUN_SERVICE':
        case 'REPORT_STATS_SECRETARY':
        case 'REPORT_OPEN_CLOSED':
          this.showReportType = true;
          break;

        case 'REPORT_TOTAL':
          this.showReportType = true;
          this.showOffice = true;
          this.showContestType = true;
          break;

        default:
          this.showReportType = false;
          this.showOffice = false;
          this.showContestType = false;
          break;
      }

    },

    downloadReport(report) {

      this.filterForm.download = true;

      switch (report) {
        case 'REPORT_GENERAL':
          this.generalReport();
          break;
        case 'REPORT_GOV_SERVICE':
          this.govServiceReport();
          break;
        case 'REPORT_MUN_SERVICE':
          this.munServiceReport();
          break;
        case 'REPORT_NRK':
          this.nrkReport();
          break;
        case 'REPORT_STATS_SECRETARY':
          this.statsSecretaryReport();
          break;
        case 'REPORT_OPEN_CLOSED':
          this.openClosedReport();
          break;
        case 'REPORT_QUESTION_DATA':
          this.questionDataReport();
          break;

        case 'REPORT_TOTAL':
          this.totalReport();
          break;

        case 'REPORT_RRK':
          this.rrkReport();
          break;

      }
    },
    rrkReport() {
      this.axios.get(this.$config.urls.report.rrk.url, this.getAxiosConfig({...this.filterForm}))
          .then(response => {

            if (this.filterForm.download)
              this.createDownloadLink(response, this.currentReport, this.filterForm.format);

          }).catch(() => {
      });
    },
    totalReport() {
      this.axios.get(this.$config.urls.report.total.url, this.getAxiosConfig({...this.filterForm}))
          .then(response => {

            if (this.filterForm.download)
              this.createDownloadLink(response, this.currentReport, this.filterForm.format);

          }).catch(() => {
      });
    },

    generalReport() {
      this.axios.get(this.$config.urls.report.general.url, this.getAxiosConfig({...this.filterForm}))
          .then(response => {

            if (this.filterForm.download)
              this.createDownloadLink(response, this.currentReport, this.filterForm.format);

          });
    },

    govServiceReport() {
      this.axios.get(this.$config.urls.report.govService.url, this.getAxiosConfig({...this.filterForm}))
          .then(response => {
            if (this.filterForm.download)
              this.createDownloadLink(response, this.currentReport, this.filterForm.format);
          });
    },

    munServiceReport() {
      this.axios.get(this.$config.urls.report.munService.url, this.getAxiosConfig({...this.filterForm}))
          .then(response => {
            if (this.filterForm.download)
              this.createDownloadLink(response, this.currentReport, this.filterForm.format);
          });
    },

    statsSecretaryReport() {
      this.axios.get(this.$config.urls.report.statsSecretary.url, this.getAxiosConfig({...this.filterForm}))
          .then(response => {
            if (this.filterForm.download)
              this.createDownloadLink(response, this.currentReport, this.filterForm.format);
          });
    },

    nrkReport() {
      this.axios.get(this.$config.urls.report.nrk.url, this.getAxiosConfig({...this.filterForm}))
          .then(response => {
            if (this.filterForm.download)
              this.createDownloadLink(response, this.currentReport, this.filterForm.format);
          });
    },

    openClosedReport() {
      this.axios.get(this.$config.urls.report.openClosed.url, this.getAxiosConfig({...this.filterForm}))
          .then(response => {
            if (this.filterForm.download)
              this.createDownloadLink(response, this.currentReport, this.filterForm.format);
          });
    },

    questionDataReport() {
      this.axios.get(this.$config.urls.report.questionData.url, this.getAxiosConfig({...this.filterForm}))
          .then(response => {
            if (this.filterForm.download)
              this.createDownloadLink(response, this.currentReport, this.filterForm.format);
          });
    },

  }
}
</script>

<style scoped>

</style>
